import jsBridge from './utils/bridge.mjs';
import { API_LOGIN, API_OPEN_CUSTOMER_SERVICE_CHAT, API_UPDATE_MESSAGE_UNREAD_COUNT, API_GET_SYSTEM_SETTING, API_OPEN_SYSTEM_SETTING, API_UPDATE_LOGIN_USER } from './utils/constant.mjs';
/**
 * 跳转登录
 * @returns
 */
export function login(params = {}) {
    return jsBridge
        .callPromise({
        minVersion: '1.0.3',
        timeout: 0
    }, API_LOGIN, params)
        .then((res) => {
        if (res.data && res.data.userId) {
            // ios 返回的 userId 为数字
            res.data.userId += '';
        }
        return res;
    });
}
/**
 * 打开客服会话界面
 */
export function openCustomerServiceChat(params = {}) {
    if (!params) {
        params = {};
    }
    if (!params.extInfo) {
        params.extInfo = {};
    }
    return jsBridge.callPromise({
        minVersion: '1.0.4'
    }, API_OPEN_CUSTOMER_SERVICE_CHAT, params);
}
/**
 * 更新消息未读数
 */
export function updateMessageUnreadCount(params) {
    if (params.value < 0) {
        params.value = 0;
    }
    return jsBridge.callPromise({
        minVersion: '1.0.9'
    }, API_UPDATE_MESSAGE_UNREAD_COUNT, params);
}
export var SystemSettingType;
(function (SystemSettingType) {
    /**
     * 设置首页
     */
    SystemSettingType["Index"] = "";
    /**
     * 推送设置页
     */
    SystemSettingType["Notification"] = "notification";
})(SystemSettingType || (SystemSettingType = {}));
/**
 * 获取系统设置
 */
export function getSystemSetting(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.1.0'
    }, API_GET_SYSTEM_SETTING, params);
}
/**
 * 打开系统设置页面
 */
export function openSystemSetting(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.1.0'
    }, API_OPEN_SYSTEM_SETTING, params);
}
/**
 * 更新登录用户
 */
export function updateLoginUser(params) {
    return jsBridge.callPromise({
        minVersion: '1.1.4',
        /**
         * 客户端暂不支持
         */
        iOSMinVersion: '9.9.9',
        androidMinVersion: '9.9.9'
    }, API_UPDATE_LOGIN_USER, params);
}
